// extracted by mini-css-extract-plugin
export var absoluteContainer = "RightSideWrapper-module__absoluteContainer___GzFU6";
export var large = "1084px";
export var wrapper = "RightSideWrapper-module__wrapper___SOj6K";